import { BasicType } from "@easy-email-pro-core/constants";
import { ElementChildren, ImageElement } from "@easy-email-pro-core/typings";
import { BlockRenderer } from "../BlockRenderer";
import { isValidReactChildren } from "@easy-email-pro-core/utils/isValidReactChildren";
import React from "react";
import { RecursivePartial } from "@easy-email-pro-core/typings/helper";

export type ImageProps = RecursivePartial<ImageElement["attributes"]> & {
  idx?: string | null;
  children?: ElementChildren | ImageElement["children"];
  data?: ImageElement["data"];
};

export function Image(props: ImageProps) {
  const { data, idx, children: propsChildren, ...rest } = props;

  const node: ImageElement = {
    type: BasicType.IMAGE,
    data: data || {},
    attributes: { ...rest },
    children: isValidReactChildren(propsChildren) ? [] : propsChildren || [],
  };

  return (
    <BlockRenderer
      idx={idx}
      node={node}
      children={isValidReactChildren(propsChildren) ? propsChildren : null}
    />
  );
}
